/**
 *Created by jmmartinez on 28/09/19
 *  v 1.1 30/09/2019 Añadido getElementoConfigCodigoIdNombreTemporada
 *  v 1.2 20/11/2019 Añadido loadTodasPaginas: true a getGridConfigCodigoIdNombre y a getGridConfig
 *  v 1.3 09/02/2020 Añadido campo ifid al gridConfig en los métodos
 *  v 1.4 10/02/2020 Añadido campo visibilidad en columnas de gridConfig.
 *  v 1.5 16/03/2020 Añadido método getOnElementoNewCodigoIdNombre.
 *  v 1.6 20/03/2020 Añadido a getGridConfigNombre y getGridConfigCodigoIdNombre -> editable: true y tipoGrid: "reactdatagrid",
 *  v 1.7 22/03/2020 Añadido a getGridConfigNombreAncho
 *  v 1.8 19/09/2020 EDITABLE: FALSE en todos los constructores mientras solucionamos problema de Firefox
 *  v 1.9 21/09/2020 En getGridConfigCodigoIdNombre, se añade el filtro fijo para que no salga codigoid== 0
 *  v.2.0 01/10/2020 Cambiado a framework2
 *  v.2.1 06/10/2020 Cambiado a tipoGrid: "reactdatagrid" y elementosPorPagina: 8
 *  v.2.2 22/11/2020 Cambiado getGridConfigCodigoIdNombre, con asignadion de editable general y en la columna nombre.
 *  v.2.2 24/03/2021 creada variable global ELEMENTOS_POR_PAGINA para asignarla a la propiedad elementosPorPagina

 *  v.2.3 06/05/2022 Fusionado Sidemur y Planifikator
 *  v.2.4 31/05/2022 Añadidos parámetros anchoCodigoId y anchoNombre a getGridConfigCodigoIdNombre
 *  v.2.5 24/04/2023 Añadido mostrarModificar: true en los generadores de gridConfig.
 *  **/

import {PAGINACIONTIPO_NORMAL} from "../UI/GridPaginado";
import {
    servicioRestful,
    servidor,
    servicioRestfulCompleto,
    servicioRestfulMinimo
} from "../../../dental/Configuracion";
import {BUSQUEDACAMPOTIPO_CADENA, FILTRO_DISTINTO, FILTRO_IGUAL} from "../UI/FormularioGridBusqueda";
import {CAMPOTIPO_CADENA} from "../UI/TiposCampos" ;
import {CELLTIPO_CADENA, COLUMNVISIBLE_SIEMPRE, COLUMNVISIBLE_VARIABLE} from "../UI/TiposCeldas"

let ELEMENTOS_POR_PAGINA= 0;

export const getGridConfig = (className, ifid) => {
    return {
        ifid: ifid ? ifid : className,
        columnas: [
        ],
        elementosPorPagina: ELEMENTOS_POR_PAGINA,
        paginacionTipo: PAGINACIONTIPO_NORMAL,
        url: servidor + servicioRestfulMinimo,
        className: className,
        busquedaCampos: [],
        noMostrarCero: true,
        showAcciones: [],
        showAllAcciones: true,
        loadTodasPaginas: true,
        editable: false,
        tipoGrid: "reactdatagrid",
        mostrarModificar: true,
        //mostrarEliminar: true,
    };
}

export const getGridConfigCodigoIdNombre = (className, ifid, anchoCodigoId, anchoNombre) => {
    let anchoCodigoIdReal= anchoCodigoId ? anchoCodigoId : 100;
    let anchoNombreReal= anchoNombre ? anchoNombre : 300;
    return {
        ifid: ifid ? ifid : className,
        columnas: [
            {campo:"codigoid", titulo: "Codigo", tipo: CELLTIPO_CADENA, ancho: anchoCodigoIdReal, visibilidad: COLUMNVISIBLE_VARIABLE},
            {campo:"nombre", titulo: "Nombre", tipo: CELLTIPO_CADENA, ancho: anchoNombreReal, editable: true},
        ],
        ordenInicial:[{nombreCampo:"nombre", asc: true}],
        elementosPorPagina: ELEMENTOS_POR_PAGINA,
        paginacionTipo: PAGINACIONTIPO_NORMAL,
        //url: servidor + servicioRestfulCompleto,
        url: servidor + servicioRestfulMinimo,
        className: className,
        busquedaCampos: [
            {campo:"codigoid", titulo: "Codigo", tipo: BUSQUEDACAMPOTIPO_CADENA, cols: 2, icon:"barcode"},
            {campo:"nombre", titulo: "Nombre", tipo: BUSQUEDACAMPOTIPO_CADENA, cols: 4, icon:"new-text-box", editable: true},
        ],
        filtroFijo: [{nombreCampo: "codigoid", tipo: FILTRO_DISTINTO,  valor: "0"}],
        noMostrarCero: true,
        loadTodasPaginas: true,
        editable: true,
        tipoGrid: "reactdatagrid",
        mostrarModificar: true,
        //mostrarEliminar: true,
    };
}

export const getGridConfigNombre = (className, ifid) => {
    return getGridConfigNombreAncho(className, ifid, 300, 4);
}

export const getGridConfigNombreAncho = (className, ifid, anchoNombre, colsAnchoBusqueda) => {
    let colsAnchoBusquedaReal= colsAnchoBusqueda ? colsAnchoBusqueda : 4;
    return {
        ifid: ifid ? ifid : className,
        columnas: [
            {campo:"nombre", titulo: "Nombre", tipo: CELLTIPO_CADENA, ancho:anchoNombre},
        ],
        ordenInicial:[{nombreCampo:"nombre", asc: true}],
        elementosPorPagina: ELEMENTOS_POR_PAGINA,
        paginacionTipo: PAGINACIONTIPO_NORMAL,
        url: servidor + servicioRestfulMinimo,
        className: className,
        busquedaCampos: [
            {campo:"nombre", titulo: "Nombre", tipo: BUSQUEDACAMPOTIPO_CADENA, cols: colsAnchoBusquedaReal, icon:"new-text-box"},
        ],
        noMostrarCero: true,
        loadTodasPaginas: true,
        editable: false,
        tipoGrid: "reactdatagrid",
        mostrarModificar: true,
        //mostrarEliminar: true,
    };
}

export const getGridConfigNombreAnchoCompleto = (className, ifid, anchoNombre) => {
    let gridConfig= getGridConfigNombreAncho(className, ifid, anchoNombre);
    gridConfig.url= servidor + servicioRestfulCompleto;
    return gridConfig;
}


export const getElementoConfig= (className) => {
    return {
        url: servidor + servicioRestfulCompleto,
        urlFK: servidor + servicioRestfulMinimo,
        className: className,
        campos: [],
    }
}

export const getElementoConfigNombre = (className) => {
    return {
        url: servidor + servicioRestfulCompleto,
        urlFK: servidor + servicioRestfulMinimo,
        className: className,
        campos: [
            {campo:"nombre", titulo: "Nombre", tipo: CAMPOTIPO_CADENA,  icon:"new-text-box", cols: 6, obligatorio: true},
        ],
    }
}

export const getElementoConfigCodigoIdNombre = (className) => {
    return {
        url: servidor + servicioRestfulCompleto,
        urlFK: servidor + servicioRestfulMinimo,
        className: className,
        campos: [
            {campo:"codigoid", titulo: "Codigo", tipo: CAMPOTIPO_CADENA, icon:"barcode", cols: 2, obligatorio: true},
            {campo:"nombre", titulo: "Nombre", tipo: CAMPOTIPO_CADENA,  icon:"new-text-box", cols: 6, obligatorio: true},
        ],
    }
}


export const getOnElementoNewCodigoIdNombre= () => {
    return () => {
        let newElemento = {
            codigo: 0,
            nombre: "",
        }
        return newElemento;
    }
}
